<template>
  <div>
    <el-row class="mb10">
      <el-button size="mini" icon="el-icon-back" @click="goBack">返回场景列表</el-button>
      <span v-if="sceneInfo.scene_name" style="margin-left: 12px; font-weight: bold;">
        {{ sceneInfo.scene_name }}
        <el-tag size="mini" type="info" style="margin-left: 8px;">{{ sceneInfo.service_type_label }}</el-tag>
      </span>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="10">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>服务产品</span>
            <el-button style="float: right;" type="primary" size="mini" @click="handleEditProduct()">添加产品</el-button>
          </div>
          <el-table
            ref="productTable"
            :height="wheight - 300"
            v-loading="productListLoading"
            :data="productList"
            highlight-current-row
            :row-class-name="productRowClassName"
            style="width: 100%"
            @current-change="handleCurrentProductChange">
            <el-table-column label="ID" prop="id" width="60"></el-table-column>
            <el-table-column label="产品名称" prop="product_name"></el-table-column>
            <el-table-column label="排序" width="90">
              <template slot-scope="scope">
                <el-input v-model="scope.row.sort" size="mini" @change="changeProductSort(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="110">
              <template slot-scope="scope">
                <el-button type="text" @click.stop="handleEditProduct(scope.row)">编辑</el-button>
                <el-button type="text" style="color: red" @click.stop="deleteProduct(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>

      <el-col :span="14">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>服务内容</span>
            <el-button style="float: right;" type="primary" size="mini" @click="handleEditContent()">添加内容</el-button>
          </div>
          <el-table
            ref="contentTable"
            :height="wheight - 300"
            v-loading="contentListLoading"
            :data="contentList"
            row-key="id"
            style="width: 100%"
            @select="handleSelectContentChange"
            @select-all="handleSelectContentChange">
            <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
            <el-table-column label="服务内容ID" prop="id" width="110"></el-table-column>
            <el-table-column label="服务ID" width="125">
              <template slot-scope="scope">
                <span>{{ scope.row.service_id || '—' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="服务内容" prop="content_name" min-width="120"></el-table-column>
            <el-table-column
              label="内容描述"
              prop="content_desc"
              min-width="160"
              show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="排序" width="90">
              <template slot-scope="scope">
                <el-input v-model="scope.row.sort" size="mini" @change="changeContentSort(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="110">
              <template slot-scope="scope">
                <el-button type="text" @click="handleEditContent(scope.row)">编辑</el-button>
                <el-button type="text" style="color: red" @click="deleteContent(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center" style="margin: 20px 0">
      <el-button size="medium" type="success" :loading="submitLoading" @click="submitProductContent">
        保存更改
      </el-button>
    </el-row>

    <el-dialog title="编辑服务产品" :visible.sync="productDialogVisible" width="420px">
      <el-form :model="productForm" label-width="90px">
        <el-form-item label="产品名称">
          <el-input v-model="productForm.product_name" class="input-b"></el-input>
        </el-form-item>
        <el-form-item label="icon图片">
          <div @click="handleHomeImgChange" class="upload-box">
            <img v-if="productForm.icon" :src="wximageurl + productForm.icon" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </div>
          <imgPicker
            :dialog-visible="homeimgDialog"
            :sc-status="isGetImage"
            @chooseImg="pickImg"
            @closeImgDialog="closeHomeImgDialog">
          </imgPicker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="productDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitProductForm">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑服务内容" :visible.sync="contentDialogVisible" width="420px">
      <el-form :model="contentForm" label-width="90px">
        <el-form-item label="服务内容">
          <el-input v-model="contentForm.content_name" class="input-b"></el-input>
        </el-form-item>
        <el-form-item label="内容描述">
          <el-input v-model="contentForm.content_desc" class="input-b" type="textarea" :rows="3"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="contentDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitContentForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import imgPicker from '@/components/imageselect'
import {
  getServiceSceneInfo,
  getServiceSceneContentConfig,
  saveServiceProduct,
  saveServiceContent,
  deleteServiceProduct,
  deleteServiceContent,
  saveServiceSceneProductContent
} from '@/api/serviceManagement'

export default {
  components: {
    imgPicker
  },
  data() {
    return {
      sceneId: 0,
      sceneInfo: {},
      productList: [],
      contentList: [],
      selectProductId: 0,
      contentIds: [],
      productListLoading: false,
      contentListLoading: false,
      submitLoading: false,
      productDialogVisible: false,
      contentDialogVisible: false,
      homeimgDialog: false,
      isGetImage: false,
      productForm: {
        id: 0,
        scene_id: 0,
        product_name: '',
        sort: 0,
        icon: ''
      },
      contentForm: {
        id: 0,
        scene_id: 0,
        content_name: '',
        content_desc: '',
        sort: 0
      }
    }
  },
  computed: {
    ...mapGetters(['wheight'])
  },
  methods: {
    goBack() {
      const path = this.$route.path.replace(/\/[^/]+_content(\/.*)?$/, '')
      this.$router.push({ path })
    },
    loadSceneInfo() {
      getServiceSceneInfo({ id: this.sceneId }).then(response => {
        this.sceneInfo = response.data.data || {}
      })
    },
    loadSceneContentConfig(productId) {
      this.contentListLoading = true
      const params = {
        scene_id: this.sceneId,
        product_id: productId || ''
      }
      getServiceSceneContentConfig(params).then(response => {
        const data = response.data.data || {}
        this.productList = data.product_list || []
        this.contentList = data.content_list || []
        this.contentIds = data.checked_content_ids || []
        this.$nextTick(() => {
          this.restoreProductCurrentRow()
          if (this.$refs.contentTable) {
            this.$refs.contentTable.clearSelection()
            this.contentIds.forEach(contentId => {
              const content = this.contentList.find(item => item.id == contentId)
              if (content) {
                this.$refs.contentTable.toggleRowSelection(content, true)
              }
            })
          }
        })
        this.contentListLoading = false
      }).catch(() => {
        this.contentListLoading = false
      })
    },
    productRowClassName({ row }) {
      return row && row.id == this.selectProductId ? 'product-row-selected' : ''
    },
    restoreProductCurrentRow() {
      if (!this.$refs.productTable || !this.selectProductId) return
      const current = this.productList.find(item => item.id == this.selectProductId)
      if (current) {
        this.$refs.productTable.setCurrentRow(current)
      }
    },
    handleCurrentProductChange(row) {
      if (!row) return
      if (this.selectProductId == row.id) return
      this.selectProductId = row.id
      this.loadSceneContentConfig(row.id)
    },
    handleSelectContentChange(selection) {
      if (!this.selectProductId) {
        this.$message.warning('请先选择服务产品')
        if (this.$refs.contentTable) {
          this.$refs.contentTable.clearSelection()
        }
        return
      }
      this.contentIds = selection.map(item => item.id)
    },
    submitProductContent() {
      if (!this.selectProductId) {
        this.$message.warning('请选择服务产品')
        return
      }
      this.submitLoading = true
      saveServiceSceneProductContent({
        scene_id: this.sceneId,
        product_id: this.selectProductId,
        content_ids: this.contentIds
      }).then(response => {
        if (response.data.data.success) {
          this.$message.success('保存成功')
        }
        this.submitLoading = false
        this.loadSceneContentConfig(this.selectProductId)
      }).catch(() => {
        this.submitLoading = false
      })
    },
    handleEditProduct(row) {
      this.productDialogVisible = true
      if (row) {
        this.productForm = {
          id: row.id,
          scene_id: this.sceneId,
          product_name: row.product_name,
          sort: row.sort,
          icon: row.icon || ''
        }
      } else {
        this.productForm = {
          id: 0,
          scene_id: this.sceneId,
          product_name: '',
          sort: 0,
          icon: ''
        }
      }
    },
    handleEditContent(row) {
      this.contentDialogVisible = true
      if (row) {
        this.contentForm = {
          id: row.id,
          scene_id: this.sceneId,
          content_name: row.content_name,
          content_desc: row.content_desc || '',
          sort: row.sort
        }
      } else {
        this.contentForm = {
          id: 0,
          scene_id: this.sceneId,
          content_name: '',
          content_desc: '',
          sort: 0
        }
      }
    },
    submitProductForm() {
      if (!this.productForm.product_name) {
        this.$message.warning('请输入产品名称')
        return
      }
      saveServiceProduct(this.productForm).then(response => {
        if (response.data.data.success) {
          this.$message.success(this.productForm.id ? '更新成功' : '添加成功')
          this.productDialogVisible = false
          this.loadSceneContentConfig(this.selectProductId)
        }
      })
    },
    submitContentForm() {
      if (!this.contentForm.content_name) {
        this.$message.warning('请输入服务内容')
        return
      }
      saveServiceContent(this.contentForm).then(response => {
        if (response.data.data.success) {
          this.$message.success(this.contentForm.id ? '更新成功' : '添加成功')
          this.contentDialogVisible = false
          this.loadSceneContentConfig(this.selectProductId)
        }
      })
    },
    changeProductSort(row) {
      saveServiceProduct({
        id: row.id,
        scene_id: this.sceneId,
        product_name: row.product_name,
        sort: row.sort,
        icon: row.icon || ''
      }).then(response => {
        if (response.data.data.success) {
          this.$message.success('排序更新成功')
          this.loadSceneContentConfig(this.selectProductId)
        }
      })
    },
    changeContentSort(row) {
      saveServiceContent({
        id: row.id,
        scene_id: this.sceneId,
        content_name: row.content_name,
        content_desc: row.content_desc || '',
        sort: row.sort
      }).then(response => {
        if (response.data.data.success) {
          this.$message.success('排序更新成功')
          this.loadSceneContentConfig(this.selectProductId)
        }
      })
    },
    deleteProduct(row) {
      this.$confirm('此操作将永久删除该产品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteServiceProduct({ id: row.id }).then(response => {
          if (response.data.data.success) {
            this.$message.success('删除成功')
            if (this.selectProductId === row.id) {
              this.selectProductId = 0
            }
            this.loadSceneContentConfig(this.selectProductId)
          }
        })
      }).catch(() => {})
    },
    deleteContent(row) {
      this.$confirm('此操作将永久删除该内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteServiceContent({ id: row.id }).then(response => {
          if (response.data.data.success) {
            this.$message.success('删除成功')
            this.loadSceneContentConfig(this.selectProductId)
          }
        })
      }).catch(() => {})
    },
    handleHomeImgChange() {
      this.homeimgDialog = true
      this.isGetImage = true
    },
    pickImg(data) {
      this.productForm.icon = data.url
      this.homeimgDialog = false
    },
    closeHomeImgDialog() {
      this.homeimgDialog = false
    }
  },
  mounted() {
    this.sceneId = Number(this.$route.params.id)
    if (!this.sceneId) {
      this.$message.error('缺少场景ID')
      this.goBack()
      return
    }
    this.loadSceneInfo()
    this.loadSceneContentConfig()
  },
  watch: {
    '$route.params.id'(id) {
      this.sceneId = Number(id)
      if (this.sceneId) {
        this.selectProductId = 0
        this.loadSceneInfo()
        this.loadSceneContentConfig()
      }
    }
  }
}
</script>

<style scoped>
.upload-box {
  width: 80px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.upload-box .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  object-fit: cover;
  display: block;
}
</style>
<style>
/* el-table 行 class 挂在子节点上，需非 scoped 才能稳定覆盖 hover */
.el-table .product-row-selected > td {
  background-color: #ecf5ff !important;
}
.el-table .product-row-selected:hover > td {
  background-color: #d9ecff !important;
}
</style>
